import { c as _c } from "react/compiler-runtime";
import { FormSelect, PrimaryButton } from '@systemeio/ui';
import { chooseSplitTestVariant } from 'modules/funnels/funnel/api/funnel-api';
import { useBTestFunnelSteps } from 'modules/funnels/funnel/hooks/use-b-test-funnel-step';
import { useFunnelStepTests } from 'modules/funnels/funnel/hooks/use-funnel-step-tests';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useGoalTestFunnelSteps } from 'modules/funnels/funnel/hooks/use-goal-test-funnel-step';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { ChooseSplitTestVariantErrorsInterface, ChooseSplitTestVariantInterface } from 'modules/funnels/funnel/types/funnel-tests-interface';
import { getAllowedStepsAsGoal, getAllowedStepsAsVariant } from 'modules/funnels/funnel/utils/split-tests-utils';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: ChooseSplitTestVariantInterface = {
  goalFunnelStep: undefined,
  funnelStepB: undefined
};
const defaultErrors: ChooseSplitTestVariantErrorsInterface = {
  fields: {
    goalFunnelStep: '',
    funnelStepB: ''
  }
};
interface ChooseTestVariantModalProps {
  funnelId: FunnelId;
  funnelStep: FunnelStepInterface;
}
function ChooseTestVariantModal(t0) {
  const $ = _c(32);
  const {
    funnelId,
    funnelStep
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const {
    mutateSplitTest
  } = useFunnelStepTests(funnelStep.id);
  const [shouldFetchFieldsData, setShouldFetchFieldsData] = useState(false);
  const {
    bFunnelStepsData
  } = useBTestFunnelSteps(funnelStep?.id, shouldFetchFieldsData);
  const {
    goalFunnelStepsData
  } = useGoalTestFunnelSteps(funnelStep?.id, shouldFetchFieldsData);
  let t1;
  if ($[0] !== funnelStep || $[1] !== mutateFunnelStepsList || $[2] !== mutateSplitTest) {
    t1 = async data => {
      await fetchWithFieldErrors(async () => {
        if (funnelStep) {
          const response = await chooseSplitTestVariant(funnelStep.id, data);
          await mutateSplitTest(response.data, false);
          await mutateFunnelStepsList(data_0 => {
            if (data_0) {
              return data_0.map(funnelStep_0 => {
                const isFunnelStepAOrB = funnelStep_0.id === response.data.funnelStepA.id || funnelStep_0.id === response.data.funnelStepB.id;
                const isGoalFunnelStep = funnelStep_0.id === response.data.goalFunnelStep.id;
                const currentSplitTest = isFunnelStepAOrB ? {
                  id: response.data.id,
                  funnelStepA: {
                    id: response.data.funnelStepA.id,
                    page: response.data.funnelStepA.page
                  },
                  funnelStepB: {
                    id: response.data.funnelStepB.id,
                    page: response.data.funnelStepB.page
                  }
                } : funnelStep_0.currentSplitTest;
                if (funnelStep_0.id === response.data.funnelStepA.id || funnelStep_0.id === response.data.funnelStepB.id) {
                  return {
                    ...funnelStep_0,
                    currentSplitTest: {
                      id: response.data.id,
                      funnelStepA: {
                        id: response.data.funnelStepA.id,
                        page: response.data.funnelStepA.page
                      },
                      funnelStepB: {
                        id: response.data.funnelStepB.id,
                        page: response.data.funnelStepB.page
                      }
                    }
                  };
                }
                return {
                  ...funnelStep_0,
                  currentSplitTest,
                  goalFunnelStepOfAnySplitTest: isGoalFunnelStep || funnelStep_0.goalFunnelStepOfAnySplitTest
                };
              });
            }
          }, false);
        }
      }, setErrors);
    };
    $[0] = funnelStep;
    $[1] = mutateFunnelStepsList;
    $[2] = mutateSplitTest;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onCreate = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.preventDefault();
      setOpened(true);
      setShouldFetchFieldsData(true);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.funnel.split_tests.choose_variant");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <PrimaryButton onClick={t2}>{t3}</PrimaryButton>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("dashboard.funnel.split_tests.choose_variant_modal_title");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpened(false);
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== bFunnelStepsData || $[13] !== errors || $[14] !== t) {
    t7 = {
      field: "funnelStepB",
      onRender: (value, onChange) => <FormSelect key="funnel-step-b" className="sm:min-w-0" data={getAllowedStepsAsVariant(bFunnelStepsData)} label={t("dashboard.funnel.split_tests.variant_funnel_step")} value={value} onChange={value_0 => onChange(value_0)} placeholder={t("dashboard.funnel.split_tests.choose_page")} required={true} withoutCloseIcon={true} error={errors.fields.funnelStepB} />
    };
    $[12] = bFunnelStepsData;
    $[13] = errors;
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== errors || $[17] !== goalFunnelStepsData || $[18] !== t) {
    t8 = {
      field: "goalFunnelStep",
      onRender: (value_1, onChange_0) => <FormSelect key="funnel-step-goal-page" className="sm:min-w-0" data={getAllowedStepsAsGoal(goalFunnelStepsData)} label={t("dashboard.funnel.split_tests.goal_funnel_step")} value={value_1} onChange={value_2 => onChange_0(value_2)} placeholder={t("dashboard.funnel.split_tests.choose_page")} required={true} withoutCloseIcon={true} error={errors.fields.goalFunnelStep} />
    };
    $[16] = errors;
    $[17] = goalFunnelStepsData;
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = [t7, t8];
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = ["funnelStepB", "goalFunnelStep"];
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== onCreate || $[25] !== opened || $[26] !== t5 || $[27] !== t9) {
    t11 = <CreateModal fullCaption={t5} opened={opened} onClose={t6} defaultValues={defaultValues} needToast={false} creatable={t9} onCreate={onCreate} requiredFields={t10} />;
    $[24] = onCreate;
    $[25] = opened;
    $[26] = t5;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t4) {
    t12 = <>{t4}{t11}</>;
    $[29] = t11;
    $[30] = t4;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
}
export default ChooseTestVariantModal;